<div
  class="list-item hover dontgrow video learn-list-item"
  role="group"
  [attr.aria-label]="item.type"
  tabindex="0"
  (keyup.space)="itemClicked(item)"
  (keyup.enter)="itemClicked(item)"
  [class.large]="large"
  [class.cursor-pointer]="selectable"
  (click)="itemClicked(item)"
>
  <div class="list-item-container">
    <div class="image-container">
      <img [src]="item.image ? item.image : './assets/images/' + item.type + '-cover.png'" class="item-image image-border" alt="" />
      @if (item.progress == 100) {
        <div class="done-indicator">
          <fa-icon icon="check"></fa-icon>
          <span class="sr-only">completed</span>
        </div>
      }
    </div>
    <div class="main-data">
      <h3 class="fui-heading-font">{{ item.title }}</h3>
      <div class="sub-data">
        @if (item.snippet || item.description) {
          <span class="description short d-block m-y-5">{{ item.snippet || item.description }}</span>
        }
        <ul class="list-inline d-flex flex-wrap align-items-center lesson-course-metadata">
          @if (item.runtime) {
            <li class="list-inline-item">
              <p class="mb-0 bold">
                <fa-icon icon="clock" aria-hidden="true"></fa-icon>
                <span class="sr-only">duration</span>
                {{ helperService.hhmmss(item.runtime, true) }}
              </p>
            </li>
          }
          @if (item.lessons) {
            <li class="list-inline-item">
              <p class="mb-0 bold">
                <fa-icon icon="info-circle" aria-hidden="true"></fa-icon>
                <span class="sr-only">count</span>
                {{ item.lessons.length + (item.lessons.length == 1 ? " Lesson" : " Lessons") }}
              </p>
            </li>
          }
          <li class="list-inline-item">
            <p class="mb-0 bold">
              <fa-icon icon="video" aria-hidden="true"></fa-icon>
              <span class="sr-only">total</span>
              {{ item.totalVideos || "0" }} Video{{ item.totalVideos && item.totalVideos == 1 ? "" : "s" }}
            </p>
          </li>
          @if (item.subscription_only) {
            <li class="list-inline-item">
              <p class="mb-0 bold">
                <img src="./assets/icons/plus-icon-blue.png" style="width: 15px; height: 15px; margin-bottom: 2px" alt="" />
                {{ env.studioOnePlusBrandName }} Exclusive
              </p>
            </li>
          }
          @if (item.resources_link && showMaterialsLink) {
            <li class="list-inline-item bold">
              <a [href]="item.resources_link" (click)="$event.stopPropagation()" target="_blank" class="link">
                <fa-icon icon="arrow-alt-circle-down" aria-hidden="true"></fa-icon>
                <span class="sr-only">download materials</span>
                Download Materials
              </a>
            </li>
          }
        </ul>
        @if (admin || showAdd || showRemove) {
          <div class="admin-video-metadata">
            @if (item.type != "folder") {
              <button
                class="pill sm m-r-5"
                [class.green]="item.status == 'approved'"
                [class.orange]="item.status == 'pending'"
                [class.red]="item.status == 'ignored'"
                (click)="toggleApprove($event)"
                [ngbTooltip]="'Click to ' + (item.status === 'approved' ? 'Unapprove' : 'Approve')"
              >
                {{ item.status.toUpperCase() }}
              </button>
            }
            @if (item.subscription_only) {
              <span class="pill sm blue m-r-5">Subscribers Only</span>
            }
          </div>
        }
      </div>
    </div>
    @if (shouldShowButtons) {
      <div class="right-data-buttons btn-group" role="group">
        @if (showCopyLink && !showAdd && !showRemove) {
          <button type="button" class="btn btn-transparent p-2" placement="left" (click)="copyLink($event)" [ngbTooltip]="'Copy Direct Link'">
            <fa-icon icon="link" class="action circle-icon-btn" aria-hidden="true"></fa-icon>
            <span class="sr-only">copy direct link</span>
          </button>
        }
        @if (showAddToList && !showAdd && !showRemove) {
          <button
            type="button"
            class="btn btn-transparent p-2"
            (click)="pin($event)"
            placement="left"
            [ngbTooltip]="(contentService.userLearnData[item.type == 'lesson' ? 'lessons' : 'courses'][item.id]?.enrolled ? 'Remove From' : 'Add To') + ' My List'"
          >
            <fa-icon [icon]="contentService.userLearnData[item.type == 'lesson' ? 'lessons' : 'courses'][item.id]?.enrolled ? 'minus' : 'plus'" class="action circle-icon-btn"></fa-icon>
            <span class="sr-only">{{ (contentService.userLearnData[item.type == "lesson" ? "lessons" : "courses"][item.id]?.enrolled ? "Remove From" : "Add To") + " My List" }}</span>
          </button>
        }
        @if (showAdd) {
          <button type="button" class="btn btn-transparent p-2" placement="left" (click)="add($event)" [ngbTooltip]="'Add To My Library'">
            <fa-icon icon="plus" class="action circle-icon-btn green" aria-hidden="true"></fa-icon>
            <span class="sr-only">add to my library</span>
          </button>
        }
        @if (showRemove) {
          <button type="button" class="btn btn-transparent p-2" placement="left" (click)="remove($event)" [ngbTooltip]="'Remove From My Library'">
            <fa-icon icon="minus" class="action circle-icon-btn red" aria-hidden="true"></fa-icon>
            <span class="sr-only">remove from my library</span>
          </button>
        }
        @if (!showAdd && !showRemove && showChevron) {
          <a class="btn btn-transparent p-2" href="javascript:void(0);">
            <fa-icon icon="chevron-right" class="action circle-icon-btn" aria-hidden="true"></fa-icon>
            <span class="sr-only">show details</span>
          </a>
        }
      </div>
    }
    @if (showRemoveFromPost) {
      <button type="button" class="btn btn-transparent close-btn p-2" (click)="removeFromPostClicked.next(true)" ngbTooltip="close">
        <fa-icon icon="times-circle" aria-hidden="true"></fa-icon>
        <span class="sr-only">close</span>
      </button>
    }
  </div>
  @if (item.progress) {
    <div
      class="progress-indicator"
      role="progressbar"
      [attr.aria-valuenow]="item.progress"
      aria-valuemin="0"
      aria-valuemax="100"
      aria-busy="false"
      aria-label="Course progress"
      [ngStyle]="{ width: item.progress + '%' }"
    ></div>
  }
</div>
